var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5024 10.3756C14.1575 10.8069 14.2276 11.4362 14.659 11.7811C15.0903 12.126 15.7196 12.0559 16.0645 11.6245L19.5628 7.24896C20.1466 6.5187 20.1466 5.48138 19.5628 4.75112L16.0645 0.375577C15.7196 -0.0557883 15.0903 -0.1259 14.659 0.21898C14.2276 0.56386 14.1575 1.19313 14.5024 1.6245L17.2012 5.00004L0.999268 5.00004C0.446981 5.00004 -0.000732422 5.44775 -0.000732422 6.00004C-0.000732422 6.55232 0.446981 7.00004 0.999268 7.00004L17.2012 7.00004L14.5024 10.3756Z",
    fill: "#92C99A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDetails);
export default __webpack_public_path__ + "static/media/arrow-details.48b5e104d6e50b31d6d3e599f9ba3c27.svg";
export { ForwardRef as ReactComponent };